import React from 'react'
import {
  Box, Text, ImageLoader,
} from '@usap/uicomponents'
import {
  ImageUploadBox,
} from '../style/ImageUploadWMO.css'

const ImageUploadWMO = ({
  sku, selectedImages, filesUpload,
}) => {

  if (!selectedImages || !selectedImages[`${sku}`]) return null
  if (!Array.isArray(selectedImages[`${sku}`]) && selectedImages[`${sku}`].length < 1) return null

  const selectedImage = selectedImages[`${sku}`]
  const filesUploads = filesUpload[`${sku}`]

  /* filter uploaded files excluding deleted and non-photo upload */
  const correctRegex = new RegExp(/file-/i)
  const newFilterData = {}

  Object.keys(selectedImage)
    .filter(elem => Object.keys(filesUploads).includes(elem) && !correctRegex.test(elem))
    // eslint-disable-next-line array-callback-return
    .map(element => {
      newFilterData[`${element}`] = selectedImage[`${element}`]
    })

  const displayUpload = fileItem => {
    const mimeType = newFilterData[`${fileItem}`].type
    if (mimeType.includes('image')) {
      return (
        <ImageLoader
          key={`image${sku}`}
          layout="fixed"
          height="90px"
          width="90px"
          fit="cover"
          src={newFilterData[`${fileItem}`].file}
          alt={newFilterData[`${fileItem}`].id}
          cloudinaryParams="w_100,h_80"
          style={{ borderRadius: "4px" }}
        />
      )
    }
    return (
      <Text>{newFilterData[`${fileItem}`].id}</Text>
    )
  }

  return (
    <ImageUploadBox
      key={`holder${sku}`}
    >
      {Object.keys(newFilterData).map(photo => (
        <Box
          key={`imageHolder${sku}-${photo}`}
          height="90px"
          width="90px"
        >
          { displayUpload(photo) }
        </Box>
      ))}
    </ImageUploadBox>
  )
}

export default ImageUploadWMO
